import React from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import axiosHandler from "../../../utils/axiosHandler.ts";
import { AdminPage } from "../../../federation/pages";

const OrderAdmin = () => {
  const navigate = useNavigate();

  return (
    <React.Suspense fallback={<CircularProgress />}>
      <AdminPage axiosHandler={axiosHandler} navigate={navigate} />
      {/* <OrderEntryPage /> */}
    </React.Suspense>
  );
};

export default OrderAdmin;
